import { render } from "./AboutUsManagement.vue?vue&type=template&id=450da9db&scoped=true"
import script from "./AboutUsManagement.vue?vue&type=script&lang=js"
export * from "./AboutUsManagement.vue?vue&type=script&lang=js"

import "./AboutUsManagement.vue?vue&type=style&index=0&id=450da9db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450da9db"]])

export default __exports__